import Vue from "vue";

const MODULE = "fhir/";
const _FIND = "FIND";
const _LIST = "LIST";
const _LOAD = "LOAD";
const _FIND_BY_IDENTIFIER = "FIND_BY_IDENTIFIER";

export const FIND_BY_IDENTIFIER = MODULE + _FIND_BY_IDENTIFIER;
export const LOAD = MODULE + _LOAD;
export const LIST = MODULE + _LIST;
export const FIND = MODULE + _FIND;

const state = {
  byId: {},
  allIds: []
};

const getters = {
  [_FIND](state) {
    return id => state.byId[id];
  },
  [_FIND_BY_IDENTIFIER](state) {
    return identifier => {
      for (let k of state.allIds) {
        const r = state.byId[k];
        const ri = r.identifier;
        if (
          ri &&
          ri.length > 0 &&
          `${ri[0].system}|${ri[0].value}` === identifier
        ) {
          return r;
        }
      }
      return undefined;
    };
  }
};

const mutations = {
  add: (state, item) => {
    const key = `${item.resourceType}/${item.id}`;
    Vue.set(state.byId, key, item);
    if (state.allIds.includes(key)) return;
    state.allIds.push(key);
  }
};

const actions = {
  async [_LOAD]({ commit, getters }, { reference, promise }) {
    return new Promise(resolve => {
      let resource = getters[_FIND](reference);
      if (!resource) {
        promise.then(data => {
          commit("add", data);
          resolve(data);
        });
      }
      return resolve(resource);
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
